import {HistoryStorageWithMaterial} from '@domain/material-storage'
import {dataTestId} from '@hconnect/uikit'
import {SilosIcon} from '@hconnect/uikit/src/common/assets/icons'
import {Button, SvgIcon} from '@mui/material'
import React, {FC} from 'react'

interface SelectStorageButtonProps {
  storage: Pick<HistoryStorageWithMaterial, 'id' | 'name'>
  isSelected: boolean
  isDisabled: boolean
  handleSelectStorage?: (id: number) => void
}

export const SelectStorageButton: FC<SelectStorageButtonProps> = ({
  storage,
  isSelected,
  isDisabled,
  handleSelectStorage
}) => {
  return (
    <Button
      startIcon={
        <SvgIcon
          component={SilosIcon}
          inheritViewBox
          sx={
            isSelected
              ? {
                  '& path': {
                    fill: ({palette}) => palette.common.white
                  }
                }
              : undefined
          }
        />
      }
      color="secondary"
      variant={isSelected ? 'contained' : 'outlined'}
      onClick={(e) => {
        e.preventDefault()
        handleSelectStorage?.(storage.id)
      }}
      disabled={isDisabled}
      {...dataTestId('select_storage_button')}
    >
      {storage.name}
    </Button>
  )
}
